import React from "react";
import withContext from "../../utils/withContext";

export class FullScreen extends React.Component {
    componentDidMount() {

            const opts = [...this.props.options]
            window.yaContextCb.push(()=>{
                Ya.Context.AdvManager.render(...opts);
            });
    }

    render() {
        return <div id={this.props.options[0].blockId} />;
    }
}

export default withContext(FullScreen);
